export default __webpack_public_path__ + "static/char-s-37-zh-Hans-33e77148a4111aaf9e4d44f8e41a9cda.png";